import { ArrowLeft } from "@phosphor-icons/react";
import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import { IconButton } from "@/components/primitives/Button";
import type { PageHeaderProps } from "./PageHeader.types";

export const PageHeader = forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ className, title, description, eyebrow, breadcrumb, onBack, backLabel = "Go back", actions, secondaryActions, sticky, titleClassName, descriptionClassName, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bfrs-flex bfrs-min-h-[52px] bfrs-flex-col bfrs-gap-3 bfrs-border-b bfrs-border-border-strong bfrs-bg-[#fbfcfb] bfrs-px-5 bfrs-py-3 sm:bfrs-flex-row sm:bfrs-items-center sm:bfrs-justify-between",
        sticky && "bfrs-sticky bfrs-top-0 bfrs-z-40",
        className
      )}
      {...props}
    >
      <div className="bfrs-flex bfrs-min-w-0 bfrs-items-start bfrs-gap-3">
        {onBack && <IconButton aria-label={backLabel} icon={<ArrowLeft size={16} />} size="sm" variant="outline" onClick={onBack} />}
        <div className="bfrs-min-w-0">
          {breadcrumb}
          {eyebrow && <div className="bfrs-mb-1 bfrs-text-[10.5px] bfrs-font-bold bfrs-uppercase bfrs-tracking-[0.08em] bfrs-text-primary">{eyebrow}</div>}
          <h1 className={cn("bfrs-truncate bfrs-text-[20px] bfrs-font-semibold bfrs-leading-6 bfrs-text-text-primary", titleClassName)}>{title}</h1>
          {description && <p className={cn("bfrs-mt-1 bfrs-max-w-2xl bfrs-text-[12.5px] bfrs-leading-5 bfrs-text-text-muted", descriptionClassName)}>{description}</p>}
        </div>
      </div>
      {(actions || secondaryActions) && (
        <div className="bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-gap-2 sm:bfrs-justify-end">
          {secondaryActions}
          {actions}
        </div>
      )}
    </div>
  )
);

PageHeader.displayName = "PageHeader";
